// extracted by mini-css-extract-plugin
export default {"header_wrapper":"SingleHeader_header_wrapper__fYvJN","header":"SingleHeader_header__fGwa8","close_icon":"SingleHeader_close_icon__QK1-U","empty":"SingleHeader_empty__7sBLm"};